import {Util} from './util'

export interface AcceptLangs {
  [lang: string]: number
}

export class NetUtil {
  public static parseAcceptLang(alHeader: string): AcceptLangs {
    const result: AcceptLangs = {}
    const langs = (alHeader || '').split(',')
    for (const lang of langs) {
      const parts = lang.split(';')
      let val = 1
      let name = '*'
      for (const part of parts) {
        if (part.startsWith('q=')) {
          val = +(part.split('q=').pop() ?? '')
        } else {
          name = part.split('-').shift() ?? ''
        }
      }
      if (!result[name] || result[name] < val) {
        result[name] = val
      }
    }
    return result
  }

  public static getLocationParams(): {[key: string]: string} {
    if (!location || !location.search) {
      return {}
    }
    const res: {[key: string]: string} = {}
    const {search} = location
    const parts = search.slice(1).split('&')
    parts.forEach(part => {
      const key = decodeURIComponent(part.split('=')[0])
      const value = decodeURIComponent(part.split('=').slice(1).join('='))
      res[key] = value
    })
    return res
  }

  public static getUrlWithParams(params: {[key: string]: string}): string {
    const keys = Object.keys(params).map(
      k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    )
    const search = keys.length > 0 ? '?' + keys.join('&') : ''
    const {origin, pathname, hash} = location
    return `${origin}${pathname}${search}${hash}`
  }

  public static async retry<T>(
    count: number,
    delayMs: number,
    fn: () => Promise<T>,
    errCallback?: (e: unknown) => void
  ): Promise<T> {
    if (count <= 0) {
      return fn()
    }
    return fn().catch(e => {
      if (errCallback) {
        errCallback(e)
      }
      return Util.wait(delayMs).then(() =>
        NetUtil.retry(count - 1, delayMs, fn, errCallback)
      )
    })
  }

  public static async fetch(
    req: RequestInfo,
    timeout: number
  ): Promise<Response> {
    return Promise.race([
      fetch(req),
      new Promise<Response>((_, fail) => {
        setTimeout(() => fail(), timeout)
      })
    ])
  }
}
